wbApp.filter('wbCzMsMtListUniversalFlt', ['$translate', 'czMsMtRegistrySvc', function ($translate, czMsMtRegistrySvc) {
    let allLists = czMsMtRegistrySvc.lists();

    function asyncResult(input, listName) {
        if (allLists.$resolved) {
            let model = _.find(allLists[listName], { id: input });
            if (model) {
                return model.name;
            } else {
                return '';
            }
        } else {
            return $translate.instant('TXT_LOADING_DATA');
        }
    }

    asyncResult.$stateful = true;

    return asyncResult;
}]);